import { render, staticRenderFns } from "./speechDetail.vue?vue&type=template&id=1ca3b97a&scoped=true&"
import script from "./speechDetail.vue?vue&type=script&lang=js&"
export * from "./speechDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3b97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca3b97a')) {
      api.createRecord('1ca3b97a', component.options)
    } else {
      api.reload('1ca3b97a', component.options)
    }
    module.hot.accept("./speechDetail.vue?vue&type=template&id=1ca3b97a&scoped=true&", function () {
      api.rerender('1ca3b97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonSpeech/speechDetail.vue"
export default component.exports